import { gql } from 'apollo-boost';

export const refinePhraseQuery = gql`
    query RefinePhraseQuery($input: GdRefineKeywordInput!, $withExamples: Boolean!) {
        reqId: getReqId
        refineKeyword(input: $input) {
            hasMore
            words {
                phrases @include(if: $withExamples)
                count
                word
            }
        }
    }
`;
